import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';

import BackButton from '../../components/BackButton';
import Button from '../../components/Button';
import Disclaimer from '../../components/Disclaimer';
import Label from '../../components/Label';
import RadioGroup from '../../components/RadioGroup';
import StackForm from '../../components/StackForm';
import Title from '../../components/Title';

import { useGlobalData } from '../../../store';

import { getPrestamosConsumo } from '../../config';
import { getSelectedTarjeta, getSelectedTipoCuenta } from '../../helpers';

import { loadStep1, customInteraction_step1, nextStep_step1 } from '../../analytics';

import queryString from 'query-string';

const Data = props => {
  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [fail, setFail] = useState(false);

  const { setGlobalData } = useGlobalData();

  useEffect(() => {
    loadStep1();
  }, []);

  useEffect(() => {
    // NOTE: Al entrar al paso 1 hay que borrar las ofertas obtenidas y la oferta seleccionada
    if (state?.data) {
      action({ offers: null, response: null });
      setGlobalData({ plazo: '-', title: '' });
    }
  }, []); // eslint-disable-line

  const onSubmit = data => {
    const parsed = queryString.parse(window.location.search);
    const monto = parsed?.monto;
    const moneda = parsed?.moneda;

    if (!monto) {
      setShowMessage(true);
      return;
    }

    if (showMessage) {
      setShowMessage(false);
      setFail(true);
    }

    const tarjetas = getSelectedTarjeta(data.tarjeta);
    const cuentas = getSelectedTipoCuenta(data.tipo_cuenta);

    setLoading(true);

    getPrestamosConsumo({
      monto,
      cuentas,
      tarjetas,
      moneda,
      tipoPaquete: data.tipoPaquete,
    })
      .then(response => {
        action({ ...data, response });
        props.history.push('/2');
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setFail(true);
      });
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Decinos qué productos Itaú tenés.</Title>

        {showMessage && <Disclaimer message="Falta el monto." />}

        {fail && (
          <Disclaimer
            message="Ocurrió un error."
            subline="Vuelve a intentarlo o comunicate al 1784."
          />
        )}

        <Label mb={10}>¿Qué tipo de cuenta tenés?</Label>

        <RadioGroup
          checkbox
          type="pill"
          name="tipo_cuenta"
          options={[
            {
              label: 'Cta. Corriente',
              value: 'tipo_cuenta-cc',
              id: 'tipo_cuenta-cc',
            },
            {
              label: 'Caja de Ahorro',
              value: 'tipo_cuenta-ca',
              id: 'tipo_cuenta-ca',
            },
            { label: 'Ninguna', value: 'tipo_cuenta-no', id: 'tipo_cuenta-no', unique: true },
            {
              label: 'No sé qué cuenta tengo',
              value: 'tipo_cuenta-nose',
              id: 'tipo_cuenta-nose',
              unique: true,
            },
          ]}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.tipo_cuenta}
          defaultChecked={state?.data?.tipo_cuenta}
        />

        <Label mb={10}>¿Tenés tarjeta de crédito itaú?</Label>

        <RadioGroup
          onChange={() => customInteraction_step1()}
          checkbox
          type="pill"
          name="tarjeta"
          options={[
            {
              label: 'Si',
              value: 'tarjeta-si',
              id: 'tarjeta-si',
              unique: true,
            },
            {
              label: 'No',
              value: 'tarjeta-no',
              id: 'tarjeta-no',
              unique: true,
            },
          ]}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.tarjeta}
          defaultChecked={state?.data?.tarjeta}
        />

        <Label mb={10}>Tipo de cliente</Label>

        <RadioGroup
          onChange={e => setGlobalData({ tipoPaquete: e.target.value })}
          type="pill"
          name="tipoPaquete"
          options={[
            {
              label: 'Soy cliente',
              value: 'N',
              id: 'cliente',
              unique: true,
            },
            {
              label: 'Soy Paquete Full',
              value: 'F',
              id: 'paquete-full',
              unique: true,
            },
            {
              label: 'Soy Personal Bank',
              value: 'P',
              id: 'personal-bank',
              unique: true,
            },
          ]}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.tipoPaquete}
          defaultChecked={state?.data?.tipoPaquete}
        />
      </div>

      <div className="form-actions">
        <Button
          block
          type="submit"
          id="pp_siguiente_2"
          disabled={loading}
          onClick={() => nextStep_step1()}
        >
          {loading ? 'cotizando…' : 'siguiente'}
        </Button>

        <BackButton
          onClick={() => document.referrer && (window.location.href = document.referrer)}
        />
      </div>
    </StackForm>
  );
};

export default withRouter(Data);
